import { Button, Typography } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { Dialog, DialogContent, DialogFooter } from '@/components/dialog'

type DeleteRollupConfigDialogProps = {
  overlay: OverlayState
  configLabel: string
  companyName: string
  onDelete: () => void
}

// Modeled on TagDeleteConfirmationDialog, not DeleteConfirmDialog — the
// design wants a one-click confirm here, not a type-the-name guard.
export default function DeleteRollupConfigDialog({
  overlay,
  configLabel,
  companyName,
  onDelete,
}: DeleteRollupConfigDialogProps) {
  return (
    <Dialog {...overlay} title="Delete this rollup config?">
      <DialogContent>
        <Typography>
          This will permanently delete the “{configLabel}” config for{' '}
          {companyName}. Line items won&apos;t be rolled up for it going
          forward.
        </Typography>
      </DialogContent>
      <DialogFooter>
        <Button variant="text" onClick={overlay.close}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            onDelete()
            overlay.close()
          }}
        >
          Delete config
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
